import { createFeatureSelector, createSelector } from "@ngrx/store";
import { INotificationState } from "../../../interfaces/notifications/INotificationState";

export const selectNotificationState = createFeatureSelector<INotificationState>('notifications');

export const selectShouldLoadMessages = createSelector(
    selectNotificationState,
    (state: INotificationState) => !state.notifications.loaded && !state.notifications.loading
);

export const selectNotifications = createSelector(
    selectNotificationState,
    (state: INotificationState) => state.notifications.notifications
);